// src/features/insurancePlan/page/PlanGroup

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import type { ColumnsType } from 'antd/es/table';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { PlanGroupType } from '../../types/insurancePlanTypes';
import StatusTag from '../../../../common/components/Status';


const PlanGroupPage = () => {

    // Define columns for the PlanGroup table
    const PlanGroupColumns: ColumnsType<PlanGroupType> = [
        { title: "Name", dataIndex: "name", key: "name" },
        { title: "Description", dataIndex: "description", key: "description",width: 500 },
        {
            title: "Active",
            dataIndex: "isActive",
            key: "isActive",
            render: (isActive: boolean) => (
                <StatusTag status={isActive ? "Yes" : "No"} />
            ),
        },
    ];

    return (
        <div>
           
            <DynamicTable<PlanGroupType>
                tableTitle={"Plan Group Management"}
                dataApiUrl={API_ENDPOINTS.INSURANCEPLAN.SEARCH_PLANGROUP} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.INSURANCEPLAN.PLANGROUPS} // Unique query key for menus
                columns={PlanGroupColumns}
                showActions={true} // Set to true if you want Edit/Delete actions
                deleteBaseUrl={API_ENDPOINTS.INSURANCEPLAN.DELETE_PLANGROUP}
                deletePayloadField={"name"}
                // Pass the fields you want the search bar to filter
                filterConfigs={[
                    { field: "name", placeholder: "name" },
                    {
                        field: "Print",
                        type: "export",
                        exportOptions: {
                            url: API_ENDPOINTS.INSURANCEPLAN.EXPORT_PLANGROUP,
                            fileName: "PlanGroup",
                            fileType: "excel", // "csv" 
                            defaultPayload: {},
                            columns: [
                                { header: "Name", key: "name" },
                                { header: "Description", key: "description" },
                                { header: "Active", key: "isActive", transform: (val: boolean) => val === true ? "Active" : "Inactive" }]
                        }
                    }
                ]}
            />
        </div>
    );
};

export default PlanGroupPage;